
import { Options, Vue } from 'vue-class-component'

@Options({
  props: {
    msg: String
  }
})
export default class Welcome extends Vue {
  msg!: string
}
